import * as React from "react";
import { SVGProps } from "react";
function SvgDragHandleIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={8} cy={8} r={1} fill="#000" fillOpacity={0.25} />
      <circle cx={12} cy={8} r={1} fill="#000" fillOpacity={0.25} />
      <circle cx={8} cy={12} r={1} fill="#000" fillOpacity={0.25} />
      <circle cx={12} cy={12} r={1} fill="#000" fillOpacity={0.25} />
      <circle cx={8} cy={16} r={1} fill="#000" fillOpacity={0.25} />
      <circle cx={12} cy={16} r={1} fill="#000" fillOpacity={0.25} />
    </svg>
  );
}
export default SvgDragHandleIcon;
